angular.module('ui.appReload', [])

        .service("appReloadService", function ($compile, $rootScope) {
            var _this = this;
            var scope;
            var el;

            _this.show = function () {
                if (scope) {
                    var dialog = $("#confirmAppReloadDialog").data("kendoDialog");
                    dialog.open();
                    return;
                }
                scope = $rootScope.$new(true);
                el = $compile("<app-reload></app-reload>")(scope);
                angular.element("body").append(el);
            };

            _this.hide = function () {
                if (scope) {
                    scope.$destroy();
                    el.remove();
                    scope = null;
                    el = null;
                }
            };

            return _this;
        })

        .directive('appReload', function () {
            return {
                restrict: "E",
                template: '<div><div id="confirmAppReloadDialog" kendo-dialog="confirmAppReloadDialog" k-title="\'OrderManager Version Updated\'|translate"' +
                    'k-actions="appReloadDialogActions" k-modal="true" k-visible="true" k-options="confirmAppReloadDialogOptions">' +
                    '<div>{{\'It is recommended to reload current OrderManager tab in order to get the latest updates and best experience.\'|translate}}</div>' +
                    '<div style="margin-top: 1em;">{{\'Reload?\'|translate}}</div>' +
                    '</div></div>',
                controller: "AppReloadController",
                scope: {}
            };
        })

    .controller('AppReloadController', function AppReloadController($window, $scope, uiLocalization, appReloadService) {
            $scope.confirmAppReloadDialogOptions = {
                //buttonLayout: "normal"
                width: "35%"
            };

            $scope.appReloadDialogActions = [
                {
                    text: uiLocalization.translate('Yes'),
                    primary: true,
                    action: function (e) {
                        $window.location.reload(true); //reload with forcing the 'get' to try and get non cached latest version from server
                    }
                },
                {
                    text: uiLocalization.translate('No'),
                    action: function (e) {
                    }
                }
            ];
        })

    ;
